import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchGrades'
})

export class SearchGradesPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    if (pipeModifier != 'GRADE') {
      return pipeData.filter(eachItem => {
        if (eachItem['fields']['grades']) {
          return (
            eachItem['fields']['grades'].includes(pipeModifier)
          )
        }
      });
    } else {
      return pipeData
    }
  }
}